import React, { ReactChild } from 'react';
import Select, { SingleValue, components } from 'react-select';
import countryList from 'react-select-country-list';
import './index.scss';

interface Props {
  className?: string;
  selected: string;
  onSelect: (code: string) => void;
  placeholder?: React.ReactNode;
  countries?: Array<any>;
  id?: string;
  label?: string;
  error?: Array<string>;
  isSearchable?: boolean;
  flag?: ReactChild;
  showSelectedLabel?: boolean;
}

type CountryOption = {
  label: string;
  value: string;
};

const CountrySelector = ({
  className,
  selected,
  onSelect,
  countries,
  placeholder,
  label,
  error,
  isSearchable,
  id,
  flag,
  showSelectedLabel,
}: Props) => {
  const options = React.useMemo(() => countryList().getData(), []);

  const Placeholder = (props: any) => (
    <components.Placeholder {...props}>
      {!!placeholder && placeholder}
    </components.Placeholder>
  );

  const DropdownIndicator = (props: any) => (
    <components.DropdownIndicator {...props}>
      {!!flag && flag}
    </components.DropdownIndicator>
  );

  return (
    <div
      className={`country-selector ${className} ${error ? 'error' : ''} ${
        flag ? 'flag' : ''
      }`}
    >
      {label && (
        <label htmlFor="countryCode" className="label">
          {' '}
          {label}
        </label>
      )}
      <Select
        className={`${className} ${error ? 'error' : ''}`}
        options={
          countries
            ? options.filter((o) => countries.includes(o.value))
            : options
        }
        defaultValue={
          showSelectedLabel && selected
            ? options.find((o) => o.value === selected)
            : null
        }
        isSearchable={isSearchable}
        onChange={(val: SingleValue<CountryOption>) => {
          onSelect(val?.value || '');
        }}
        placeholder={showSelectedLabel ? placeholder : false}
        name={id}
        components={{ Placeholder, DropdownIndicator }}
      />
      {error && (
        <div
          className="ui pointing above prompt label"
          role="alert"
          aria-atomic="true"
        >
          {error.map((e: string) => (
            <span key={e}>{e}</span>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountrySelector;
